import React from 'react';
import { Cable} from 'lucide-react';
import TranscriptionTool from './TranscriptionTool';

const ToolsContent = () => {
  const tools = [
    { name: 'Web Monitoring', icon: <Cable size={20} />, description: 'Check your web presence on social/ search platforms' },
    { name: 'Image Generation', icon: <Cable size={20} />, description: 'Create images for any purpose' },
  ];

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Tools & Integration</h2>
      <div className="bg-white rounded-lg shadow p-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {tools.map((tool) => (
            <ToolCard key={tool.name} name={tool.name} description={tool.description} icon={tool.icon}/>
          ))}
          <TranscriptionTool /> 
        </div>
      </div>
    </div>
  );
};

const ToolCard = ({ name, description, icon }) => {
  return (
    <div className="border rounded p-4">
      <h3 className="font-medium"><span className="me-3">{icon}</span>{name}</h3>
      <p className="text-sm text-gray-500 mt-2">{description}</p>
    </div>
  );
};

export default ToolsContent;